<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:YearMonthInput
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.02.00 | 2022/10/11 | 富士通Japan株式会社    | 新規作成
// 01.03.00 | 2024/03/29 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div :class="[classDiv != '' ? classDiv : '']">
		<list-box
			:modelValue="yearValue"
			ref="dateYear"
			class="contents__input--select width-auto"
			:name="name + '（年）'"
			:list-items="disp.yearItems"
			:blank-flg="false"
			:require-flg="requireFlg"
			:group-id="groupId"
			:disabled-flg="disabledFlg"
			:tabindex="Number(tabindex) <= 0 ? tabindex:String(Number(tabindex))"
			@update:modelValue="yearValue = $event"
		/>
		年&nbsp;
		<list-box
			:modelValue="monthValue"
			ref="dateMonth"
			class="contents__input--select width-auto"
			:name="name + '（月）'"
			:list-items="disp.monthItems"
			:blank-flg="false"
			:require-flg="requireFlg"
			:group-id="groupId"
			:disabled-flg="disabledFlg"
			:tabindex="Number(tabindex) <= 0 ? tabindex:String(Number(tabindex) + 1)"
			@update:modelValue="monthValue = $event"
		/>
		月
	</div>
</template>

<script>
import ListBox from '@/components/ListBox.vue';

import { co_isEmpty } from '@/common/checkUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';

import { YEAR_MONTH_KIND } from '@/const/const.js';
import { STORE_ERROR_SET_INPUT_ERR } from '@/const/store.js';

export default {
	components: {
		'list-box': ListBox,
	},
	props: {
		name: {type: String, default: ''},						// 項目名
		requireFlg: {type: Boolean, default: false},			// true : 必須
		dateType: { type: Number, default: YEAR_MONTH_KIND.KOBO },// 日付種別
		disabledFlg: { type: Boolean, default: false },			// 活性・非活性フラグ
		tabindex: {type: String, default: '0'},					// タブインデックス
		groupId: {type: String, default: ''},					// 項目グループID
		classDiv: {type: String, default: ''},					// コントロールエリアのスタイル
	},
	emits: ['update:modelValue'],
	data: function () {
		return {
			yearValue: '',
			monthValue: '',
			dayValue: '',
			disp: {
				yearItems: [], 
				monthItems: [], 
				dayItems: [], 
				age:' '
			},
		}
	},
	computed: {

	},
	watch: {
		yearValue: function () {
			// 日付変更処理
			this.changeDate();
		},
		monthValue: function () {
			// 日付変更処理
			this.changeDate();
		},
		clear: function () {
			// 日付変更処理
			this.setValue('');
		},
		disabledFlg: function( val ) {
			if( val ) {
				// エラークリア
				this.clearError();
			}
		},
	},
	created: async function() {
		// 年月リスト作成
		this.createYearList();
		this.createMonthList();
	},
	methods: {
		// 年リスト作成
		createYearList: function () {

			let startYear = 0;
			let endYear = 0;
			let currentYear = (new Date()).getFullYear();

			// 年リスト設定
			let yearItemsList = [];
			yearItemsList.push({idCd : '', nmCd : '----'});

			if (this.dateType == YEAR_MONTH_KIND.KOBO) {
				// 公募年月
				startYear = currentYear - 1;
				endYear = currentYear + 1;

			} else if (this.dateType == YEAR_MONTH_KIND.KOBO_MOUSIKOMI) {
				// 公募年月（申込履歴検索・一覧画面（管理者用））
				startYear = 2022;
				endYear = currentYear;

			} else {
				// その他
				startYear = 1900;
				endYear = currentYear;
			}

			for (let i = startYear-1; i < endYear; i++) {
					yearItemsList.push({
										idCd : i + 1, nmCd : i + 1
										});
			}
			this.disp.yearItems = yearItemsList;

		},
		// 月リスト作成
		createMonthList: function () {

			// 月リスト設定
			let monthItemsList = [];
			monthItemsList.push({idCd : '', nmCd : '--'});
			for (let i = 0; i < 12; i++) {
					monthItemsList.push({
										idCd : this.zeroPadding(i + 1, 2), nmCd : this.zeroPadding(i + 1, 2)
										});
			}
			this.disp.monthItems = monthItemsList;

		},
		// 選択値取得
		getValue: function() {
			return this.yearValue + this.monthValue;
		},
		// 選択値設定
		setValue: function(date) {
			this.yearValue = '';
			this.monthValue = '';
			
			if (co_isEmpty(date) || date.length != 6) {
				return;
			}

			if (this.checkDate(date.substring(0, 4), date.substring(4, 6), '01')) {

				this.yearValue = date.substring(0, 4);
				this.monthValue = date.substring(4, 6);

				return;
			}
		},
		//エラー表示設定
		setError: function() {
			this.$refs.dateYear.setError();
			this.$refs.dateMonth.setError();
		},
		//エラー表示消去
		clearError: function() {
			this.$refs.dateYear.clearError();
			this.$refs.dateMonth.clearError();
		},
		// 妥当性チェック
		validate: function () {

			let retYearValidate = this.$refs.dateYear.validate();
			let retMonthValidate = this.$refs.dateMonth.validate();

			if (!retYearValidate
				|| !retMonthValidate) {
				return false;
			}

			if (co_isEmpty(this.yearValue) && co_isEmpty(this.monthValue)) {
				// 年月全て未選択の場合
				return true;
			}

			// 年月どちらかが選択されている場合
			if ( co_isEmpty(this.yearValue) ) {
				this.$store.commit( STORE_ERROR_SET_INPUT_ERR,
								{id: this.groupId, msg: co_getMessage('E0054', this.name + '（年）')});
				this.setError();
				return false;
			}

			if ( co_isEmpty(this.monthValue) ) {
				this.$store.commit( STORE_ERROR_SET_INPUT_ERR,
								{id: this.groupId, msg: co_getMessage('E0054', this.name + '（月）')});
				this.setError();
				return false;
			}

			return true;
			
		},
		// 日付有効性チェック
		checkDate: function(year, month, day) {
			if (!year || !month || !day) return false;
			if (!String(year).match(/^[0-9]{4}$/) || !String(month).match(/^[0-9]{1,2}$/) || !String(day).match(/^[0-9]{1,2}$/)) return false;

			let dateObj		= new Date(year, month - 1, day);
			let dateObjStr	= String(dateObj.getFullYear() * 10000 + (dateObj.getMonth() + 1) * 100 + dateObj.getDate() * 1);
			let checkDateStr= year + '' + month + '' + day;

			if (dateObjStr === checkDateStr) return true;

			return false;
		},
		// ゼロ埋め
		zeroPadding: function(num, len) {
			return ( Array(len).join('0') + num ).slice( -len );
		},
		// 日付変更
		changeDate: function () {
			this.$emit('update:modelValue', this.yearValue + this.monthValue);
		},
		// フォーカス設定
		focus: function() {
			this.$refs.dateYear.focus();
		}
	},
}
</script>

<style scope>
</style>